import { RPDF, Text, View } from '../common/react-pdf';
import React from 'react';
import { useScopedTranslation } from '@lmt/unicorn-shared/app/helpers/localization/useScopedTranslation';

interface Props {
  dateString: string;
  visitsCount: number;
}

export const DayVisitsCount: React.FC<Props> = (props) => {
  const i18next = useScopedTranslation('calendar.report');
  return (
    <RPDF.View style={RPDF.styles.visitsCountContainer}>
      <RPDF.Text style={RPDF.styles.titleText}>{props.dateString}</RPDF.Text>
      <RPDF.Text style={RPDF.styles.visitsCountText}>
        {i18next.t('day_visits_count')}
      </RPDF.Text>
      <RPDF.Text style={RPDF.styles.visitsCountText}>
        {props.visitsCount.toString()}
      </RPDF.Text>
    </RPDF.View>
  );
};
